import styled, { css } from 'styled-components';
import {
  BackButtonHeight,
  NavBarHeightMobile,
  SubNavBarHeightMobile,
} from '../../../const';

export const StyledButton = styled.button.withConfig({
  shouldForwardProp: (prop) =>
    !['iconPosition', 'bottomRight', 'fullsize', 'compact'].includes(prop),
})`
  --clr-main: ${({ theme }) => theme.colors.btnMain};
  --clr-white: ${({ theme }) => theme.colors.white};
  --clr-hover: ${({ theme }) => theme.colors.btnHover};

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${({ iconPosition }) =>
    iconPosition === 'end' ? 'row' : 'row-reverse'};
  column-gap: 14px;
  padding: 12px 24px;
  border-radius: 4px;
  width: ${({ fullsize, compact }) =>
    fullsize ? '100%' : compact ? '128px' : 'fit-content'};
  height: ${({ compact }) => (compact ? '35px' : 'fit-content')};
  font-size: 14px;
  line-height: 16px;
  font-weight: 700;
  transition: ${({ theme }) => theme.constants.transitionBase};
  text-transform: uppercase;
  border: 3px solid currentColor;

  ${(props) =>
    props.bottomRight &&
    css`
      margin-top: auto;
      margin-left: auto;
    `}

  svg {
    cursor: unset; /* overrides icon */
    margin: -3px -10px -5px 0; /* cheat to offset the icon */
    transition: ${({ theme }) => theme.constants.transitionBase} -250ms; /* overrides icon */
  }

  &:focus-visible {
    outline: 3px solid ${({ theme }) => theme.colors.focusRing};
    outline-offset: -7px; /* outline inset (border+outline) */
  }

  &.primary {
    color: var(--clr-white);
    background-color: var(--clr-main);
    border-color: var(--clr-main);

    &:hover {
      background-color: var(--clr-hover);
      border-color: var(--clr-hover);
    }
  }

  &.secondary {
    color: var(--clr-main);
    background-color: var(--clr-white);
    border-color: var(--clr-main);

    &:hover {
      color: var(--clr-hover);
      border-color: var(--clr-hover);
    }
  }

  &.tertiary {
    color: var(--clr-main);
    background-color: transparent;
    border: none;
    column-gap: 8px;
    padding: 0;
    border-radius: 0;
    white-space: ${({ icon }) => icon && 'nowrap'};

    svg {
      margin: 0;
    }

    &:hover {
      color: var(--clr-hover);
    }

    &:focus-visible {
      outline-offset: 0;
    }
  }

  &[disabled],
  &[disabled]:hover {
    color: ${({ theme }) => theme.colors.btnDisabledText};
    cursor: not-allowed;

    &:not(.tertiary) {
      background-color: ${({ theme }) => theme.colors.btnDisabledBg};
      border-color: ${({ theme }) => theme.colors.btnDisabledBg};
    }
  }
`;

export const StickyFiltersWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['mb', 'stickyPosition'].includes(prop),
})`
  background-color: ${({ bgColor, theme }) => bgColor ?? theme.colors.white};
  width: var(--full-width);
  max-height: 70px;
  position: -webkit-sticky;
  position: sticky;
  top: calc(
    ${NavBarHeightMobile}px + ${SubNavBarHeightMobile}px + ${BackButtonHeight}px
  );
  padding: 12px 16px;
  margin-left: -16px;
  margin-bottom: ${({ mb }) => mb ?? 40}px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;

  ${({ stickyPosition }) =>
    typeof stickyPosition === 'number' &&
    css`
      top: calc(
        ${NavBarHeightMobile}px + ${SubNavBarHeightMobile}px +
          ${BackButtonHeight}px + ${stickyPosition * 69}px
      );
    `}

  .small-btn {
    max-width: 128px;
    height: 38px;
  }
`;
